module.exports = new __parcel__URL__("empty.a99e273d.png").toString();